
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autopfand-formular/modell",
      function () {
        return require("private-next-pages/autopfand-formular/modell.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autopfand-formular/modell"])
      });
    }
  